import { COUNTRIES } from './countries.const';
// @deprecated
export const COUNTRY_CODES = COUNTRIES;
